<template>
  <el-dialog title="历史计算规则" width="1100px" class="my-dialog-template" :visible.sync="visible" top="15vh">
    <el-table :data="tableData" style="width: 100%" border :max-height="tableH"
      class="list-table" tooltip-effect="dark">
      <el-table-column prop="date" label="生效日期" width="200" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="type" label="结算规则" :show-overflow-tooltip="true">
        <div slot-scope="scope" v-html="scope.row.text"></div>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
export default {
  mixins: [],
  components: {},
  data: () => ({
    tableH:document.body.clientHeight - 400,
    tableData: [
      {
        date: "2026-9-20至今",
        text: `
        <p>1、每月18日，结算上月首期已过犹豫期（截止本月17日）且回执回访质检成功保单（法定节假日顺延）；</p>
        <p>2、如有参加活动，每月20日-25日结算上月参加活动，首期已过犹豫期且回执回访质检成功保单对应活动奖励（法定节假日顺延）；</p>
        <p>注：双录单/单录确权单需质检通过</p>
        `
      },
      {
        date: "2025-2-1至2026-9-19",
        text: `
        <p>1、每月18日，结算上月首期已过犹豫期（截止本月17日）且回执回访质检成功保单（法定节假日顺延）；</p>
        <p>2、如有参加活动，每月20日结算上月参加活动，首期已过犹豫期且回执回访质检成功保单对应活动奖励（法定节假日顺延）；</p>
        <p>注：双录单/单录确权单需质检通过</p>
        `
      },
      {
        date: "2024-7-24至2025-1-31",
        text: `
        <p>1、每月5日，结算上月1-15日首期已过犹豫期（截止本月4日）且回执回访质检成功保单（法定节假日顺延）；</p>
        <p>2、每月20日，结算上月16-31日首期已过犹豫期（截止本月19日）且回执回访质检成功保单（法定节假日顺延）；</p>
        <p>3、如有参加活动，每月25日结算上月参加活动，首期已过犹豫期且回执回访质检成功保单对应活动奖励（法定节假日顺延）；</p>
        <p>注：双录单/单录确权单需质检通过</p>
        `
      },
      {
        date: "2023-11-31至2024-7-24",
        text: `
        <p>1、每月5日，结算上月1-15日首期已过犹豫期且回执回访质检成功保单（法定节假日顺延）；</p>
        <p>2、每月20日，结算上月16-31日首期已过犹豫期且回执回访质检成功保单（法定节假日顺延）；</p>
        <p>3、如有参加活动，每月25日结算上月参加活动，首期已过犹豫期且回执回访质检成功保单对应活动奖励（法定节假日顺延）；</p>
        <p>注：双录单/单录确权单需质检通过</p>
        `
      },
      {
        date: "2023-9-11至2023-11-31",
        text: "<p>平台将于每月15号结算首期已过犹豫期（犹豫期截止时间为当月9号）并已回访成功的保单（双录单/单录确权单需质检通过）</p>"
      },
      {
        date: "2022-9-13至2023-9-11",
        text: "<p>平台将于每月15号结算首期已过犹豫期（犹豫期截止时间为当月9号）并已回访成功的保单（双录单需质检通过）</p>"
      },
    ],
    visible:false,
  }),
  created() {},
  methods: {
    open(){
      this.visible=true;
    },
    
  },
}
</script>
<style lang='scss' scoped>

</style>